import { render, staticRenderFns } from "./SinalizadorGenVinculo.vue?vue&type=template&id=3ee7df86&"
import script from "./SinalizadorGenVinculo.vue?vue&type=script&lang=js&"
export * from "./SinalizadorGenVinculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports